import React from 'react';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import MessageCourier from '../../lib/MessageCourier';
import { CampoJuego } from '../../system/CampoJuego/CampoJuego';
import SystemClient from '../../system/SystemClient';
import ComboBoxSearch, { IComboBoxSearch } from '../Common/ComboBoxSearch';
import { IComboBoxOption } from '@fluentui/react';
import ComboBoxInput from '../../lib/FormValidator/Form/ComboBoxInput';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import useForceUpdate from '../../common/custom-hooks/useForceUpdate';
interface ICampoJuegoSelector {
  system: SystemClient;
  courier: MessageCourier;
  selectedKey: string;
  onSelect: (cj: CampoJuego) => void;
  providedList?: CampoJuego[];
  cleanOnSelect? : boolean
}

export const CampoJuegoSelector = (props: ICampoJuegoSelector) => {
  const campoJuegos = useAsyncDataCourier(
    () =>
      props.providedList
        ? Promise.resolve(props.providedList)
        : props.system.getCampoJuegoSystem().getListForDropdown(),
    [props.providedList],
    props.courier
  );
  const campoJuegoOptions = React.useMemo(() => {
    let ret: IComboBoxOption[] = [];
    if (campoJuegos) {
      ret = campoJuegos.map((entity: CampoJuego) => {
        return { key: entity.getId()!, text: entity.getNombre(), data: entity };
      });
    }

    return ret;
  }, [campoJuegos]);

  const onSelect = (opt: IComboBoxOption) => {
    const a = campoJuegos?.find((a) => a.isIdentifiedBy(String(opt.key)));
    if (a) props.onSelect(a);
  };

  return (
    <ComboBoxSearch
      selected={[props.selectedKey]}
      onSelectOption={onSelect}
      options={campoJuegoOptions}
      cleanOnSelect={props.cleanOnSelect}
    ></ComboBoxSearch>
  );
};

interface ICampoJuegoSelectorInput {
  system: SystemClient;
  courier: MessageCourier;
  input: CustomInputIfc;
  hideLabel?: boolean;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  filterByFederationId?: string;
  providedList?: CampoJuego[];
}

export const CampoJuegoSelectorInput = (props: ICampoJuegoSelectorInput) => {
  const { t, i18n } = useTranslation();
  const [currentCampoJuego, setCurrentCampoJuego] = React.useState<CampoJuego | undefined>(undefined);
  const [campoJuegoOptions, setCampoJuegoOptions] = React.useState<IComboBoxOption[]>([]);

  const campoJuegos = useAsyncDataCourier(
    () =>
      props.providedList
        ? Promise.resolve(props.providedList)
        : props.system.getCampoJuegoSystem().getListForDropdown(),
    [props.filterByFederationId, props.providedList],
    props.courier
  );
  const mapCampoJuegoOptions = (campoJuegos: CampoJuego[]) => {
    let opcionesFiltered = campoJuegos;
    if (props.filterByFederationId) {
      opcionesFiltered = campoJuegos.filter((cj) => {
        console.log(cj.getFedid());
        if (props.filterByFederationId) {
          return cj.getFedid() == +props.filterByFederationId;
        } else {
          return true;
        }
      });
    }

    const opciones = opcionesFiltered.map((entity: CampoJuego) => {
      return { key: entity.getId()!, text: getLabelFromCampoJuego(entity), data: entity };
    });
    setCampoJuegoOptions(opciones);
  };
  const selectDefaultCampoJuego = (id: string) => {
    setCurrentCampoJuego(
      campoJuegos ? campoJuegos.find((entity: CampoJuego) => entity.getId() === id) : undefined
    );
  };
  const forceUpdate = useForceUpdate();
  const getLabelFromCampoJuego = (entity: CampoJuego) => {
    const label = String(entity.getNombre()!);
    return label;
  };

  React.useEffect(() => {
    forceUpdate();
  }, [currentCampoJuego]);
  React.useEffect(() => {
    selectDefaultCampoJuego(props.input.getValue());
    mapCampoJuegoOptions(campoJuegos ? campoJuegos : []);
  }, [campoJuegos, currentCampoJuego]);

  // const getStartingSelectionCampoJuego = () => {
  //   let ret = '';
  //   if (campoJuegos) {
  //     const _entity = campoJuegos.find((e: CampoJuego) => e.getId() === props.input.getValue());
  //     if (_entity) ret = String(_entity.getId());
  //   }

  //   return ret;
  // };

  return (
    <>
      {campoJuegos && (
        <ComboBoxInput
          input={props.input}
          label={props.hideLabel ? '' : t('Campo juego ')}
          onBlur={props.onBlurCustomInput}
          options={campoJuegoOptions ? campoJuegoOptions : []}
          selectedKey={props.input.getValue()}
        />
      )}
    </>
  );
};
